import { action, makeObservable } from 'mobx';

import { LanguageCode } from './LanguageCode';
import { SiteTranslation } from './SiteTranslation';

export interface ITranslationResolver<T = SiteTranslation> {
  default: T;
  resolve: (languageCode: string) => T;
  languageCodes: string[];
}

export class TranslationResolver<T = SiteTranslation> implements ITranslationResolver<T> {
  public constructor(
    private readonly translations: Map<string, T>,
    private readonly defaultLanguageCode: string,
  ) {
    makeObservable(this);
  }

  public get default(): T {
    return this.translations.get(this.defaultLanguageCode);
  }

  public get languageCodes(): string[] {
    return [...this.translations.keys()];
  }

  @action
  public resolve(languageCode: string): T {
    if (languageCode) {
      const texts = this.translations.get(LanguageCode.normalize(languageCode));

      if (texts) {
        return texts;
      }
    }

    return this.default;
  }
}
